import React, { useContext, useEffect, useState } from 'react';
import cn from 'classnames';

import { GreetingModel, PersonModel } from '../../../../../../types/app';

import styles from './badge-group.module.scss';
import { IoEvents } from '../../../../../../types/app/signal';
import { SocketContext } from '../../socket';
import { WelcomeContainer } from '../../molecules';
import { NAME_WAITING_TIME } from '../../../utils/constants';


interface GroupViewProps {
  greeting: GreetingModel;
}

export const BadgeGroupView: React.FC<GroupViewProps> = ({ greeting }) => {
  const names = greeting.persons && greeting.persons.map(p => p.firstName);
  const queueNames = [];

  const [ currentName, setCurrentName ] = useState(names ? names[0] : '');
  const socket = useContext(SocketContext);

  function getDelayedValue(ms, val) {
    return new Promise((resolve) => setTimeout(() => { resolve(val) }, ms));
  }

  async function* getGenerator(array, startPos = 0) {
    let i = startPos;
    while (i < array.length) {
      let name = array[i];
      if (queueNames.length) {
        name = queueNames.pop();
      } else {
        if (i === array.length - 1) {
          i = 0;
        } else {
          i++;
        }
      }

      yield await getDelayedValue(NAME_WAITING_TIME, name);

    }
  }

  useEffect(() => {
    async function iterator() {
      for await (let name of getGenerator(names, 1)) {
        setCurrentName(name as string);
      }
    }

    iterator();
  }, []);

  useEffect(() => {
    socket && socket.on(IoEvents.queueNameReceived, (data) => {
      data?.firstName && queueNames.unshift(data.firstName);
    });
  }, [socket]);

  return (
    <div className={styles['individual-view']} >
      <WelcomeContainer
        className={styles['individual-view__welcome']}
      >
        {currentName}
      </WelcomeContainer>
    </div>
  );
};
